module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark font-weight-600 d-flex"
  }, [_c('span', {
    staticClass: "pointer mr-3 relative",
    on: {
      "click": function($event) {
        _vm.showingExportOptions = !_vm.showingExportOptions
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-export fs-large"
  }), _vm._v(" "), _c('span', [_vm._v("Export")]), _vm._v(" "), (_vm.showingExportOptions) ? _c('ul', {
    staticClass: "floating-menu bottom centered"
  }, _vm._l((_vm.exportOptions), function(exportOption) {
    return _c('li', {
      on: {
        "click": exportOption.action
      }
    }, [_vm._v(_vm._s(exportOption.label))])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.printAction) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": _vm.printAction
    }
  }, [_c('i', {
    staticClass: "ico ico-print fs-large"
  }), _vm._v(" "), _c('span', [_vm._v("Print")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1004b694", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1004b694"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/ExportV2.vue
// module id = 1711
// module chunks = 0